/* =====================================================================
   NO SUGAR – NSRotation (núcleo compartido: Planes, A la carta, Express)
   - Rotación de menús por conteo continuo desde fecha ancla (no por módulo de semana ISO).
   - Zona horaria fija America/Monterrey (no depende del reloj del navegador del cliente).
   - Semana ISO con año (Semana ID) para Sugar OS, por ejemplo: 2026-W44.
   - Entrega Express: mismo día si el pedido cae antes de las 15:00; si no, día siguiente.
   ===================================================================== */
(function (global) {
  'use strict';

  var TZ = 'America/Monterrey';
  var DAY = 86400000;
  // Lunes 5-Ene-2026 = Semana 2 = Menu4 (fecha ancla verificada)
  var ANCHOR_MONDAY_UTC = Date.UTC(2026, 0, 5);
  // Ciclo: Menu4 -> Menu1 -> Menu2 -> Menu3 -> Menu4 ...
  var SEQUENCE = [4, 1, 2, 3];
  var EXPRESS_CUTOFF_MINUTES = 15 * 60; // 3:00 p. m.

  function mtyParts(date) {
    var f = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    });
    var o = {};
    f.formatToParts(date).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: (+o.hour) % 24, mi: +o.minute };
  }

  // Fecha local (del navegador) que representa la hora de pared de Monterrey.
  function nowMty() {
    var p = mtyParts(new Date());
    return new Date(p.y, p.m - 1, p.d, p.h, p.mi, 0, 0);
  }

  // Lunes 00:00 (fecha local) de la semana que contiene 'date'.
  function mondayOf(date) {
    var base = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    var dow = (new Date(base).getUTCDay() + 6) % 7; // lunes = 0
    var mon = new Date(base - dow * DAY);
    return new Date(mon.getUTCFullYear(), mon.getUTCMonth(), mon.getUTCDate());
  }

  function weeksSinceAnchor(monday) {
    var utc = Date.UTC(monday.getFullYear(), monday.getMonth(), monday.getDate());
    return Math.round((utc - ANCHOR_MONDAY_UTC) / (7 * DAY));
  }

  // Menú de la semana que contiene 'date' (1..4).
  function menuForMonday(date) {
    var mon = mondayOf(date);
    var idx = ((weeksSinceAnchor(mon) % 4) + 4) % 4;
    return SEQUENCE[idx];
  }

  // Semana ISO (1..53) y año ISO de la semana que contiene 'date'.
  function isoParts(date) {
    var mon = mondayOf(date);
    var thu = new Date(mon.getFullYear(), mon.getMonth(), mon.getDate() + 3);
    var y = thu.getFullYear();
    var jan1 = Date.UTC(y, 0, 1);
    var thuUtc = Date.UTC(y, thu.getMonth(), thu.getDate());
    return { year: y, week: Math.floor((thuUtc - jan1) / (7 * DAY)) + 1 };
  }

  function isoWeekIdOf(date) {
    var p = isoParts(date);
    return p.year + '-W' + (p.week < 10 ? '0' : '') + p.week;
  }

  function isoWeekNumberOf(date) {
    return isoParts(date).week;
  }

  function currentMonday() {
    return mondayOf(nowMty());
  }

  // Texto de entrega Express según la hora de Monterrey del momento del pedido.
  function expressDeliveryText(atDate) {
    var p = mtyParts(atDate || new Date());
    var minutes = p.h * 60 + p.mi;
    if (minutes < EXPRESS_CUTOFF_MINUTES) {
      return 'Mismo día (Uber Delivery / DiDi Delivery) – pedido antes de las 3:00 p. m.';
    }
    return 'Día siguiente (programado) – pedido después de las 3:00 p. m.';
  }


  // Tipo de compra de una línea del carrito (Planes, A la carta o Express).
  function cartKind(item) {
    var props = (item && item.properties) || {};
    if (props['Tipo de compra']) return props['Tipo de compra'];
    if (props.BundleCode) return 'Planes'; // líneas anteriores sin tipo
    return 'A la carta';
  }

  // Unidades del carrito de un tipo dado.
  function countKind(cart, kind) {
    return ((cart && cart.items) || []).filter(function (i) { return cartKind(i) === kind; })
      .reduce(function (sum, i) { return sum + (parseInt(i.quantity, 10) || 0); }, 0);
  }

  // Express no puede convivir con Planes ni A la carta en el mismo pedido.
  // Devuelve un mensaje si la compra no está permitida, o null si sí.
  function mixError(kind, cart) {
    // La entrega a domicilio Express es un servicio, no un platillo: no cuenta para la mezcla.
    var items = ((cart && cart.items) || []).filter(function (i) { return cartKind(i) !== 'Envío Express'; });
    var hasExpress = items.some(function (i) { return cartKind(i) === 'Express'; });
    var hasOther = items.some(function (i) { return cartKind(i) !== 'Express'; });
    if (kind === 'Express' && hasOther) {
      return 'Tu carrito ya tiene platillos de Planes o A la carta. Express se compra en un pedido aparte: finaliza o vacía esa compra primero.';
    }
    if (kind !== 'Express' && hasExpress) {
      return 'Tu carrito tiene platillos Express. Express se compra en un pedido aparte: finaliza o vacía esa compra primero.';
    }
    return null;
  }

  global.NSRotation = {
    nowMty: nowMty,
    mondayOf: mondayOf,
    menuForMonday: menuForMonday,
    isoWeekNumberOf: isoWeekNumberOf,
    isoWeekIdOf: isoWeekIdOf,
    currentMonday: currentMonday,
    expressDeliveryText: expressDeliveryText,
    cartKind: cartKind,
    countKind: countKind,
    mixError: mixError
  };
})(typeof window !== 'undefined' ? window : globalThis);
